jQuery(document).ready(function ($) {
    

    console.log("ixact");

    // changing Location text and position
    $(".property-form form > .screen-reader-text").text("Location").css("display", "block");
    $(".property-form form > .screen-reader-text").prependTo(".property-form form > .awesomplete");

    // Changing text on fields
    // $(".idx-omnibar-min-price-container label").text("Min. Price");
    // $(".idx-omnibar-max-price-container label").text("Max. Price");
    //
    // // Adding placeholders  and dolar sign
    // $(".idx-omnibar-min-price-container input").attr("placeholder", "No min");
    // $(".idx-omnibar-max-price-container input").attr("placeholder", "No max");
    //
    // $( ".idx-omnibar-min-price-container" ).add( "<span class='dollar-sign'>$</span>" ).prependTo('.idx-omnibar-min-price-container');
    // $( ".idx-omnibar-max-price-container" ).add( "<span class='dollar-sign'>$</span>" ).prependTo('.idx-omnibar-max-price-container');

    $( "h4.search-title" ).prependTo('.idx-omnibar-form');




});